import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconMouseComponent } from "./med-icon-mouse.component";

@NgModule({
  declarations: [
    MedIconMouseComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconMouseComponent,
  ],
})
export class MedIconMouseModule { }
